(() => {
  if (window.bwBossborotDeposit) return;

  const readSelection = (component) => {
    const scope = component.closest('product-info');
    const buttons = scope?.querySelectorAll('#downpay-buy-button') || [];
    const button = buttons.length === 1 ? buttons[0] : null;
    const form = button?.closest('form');
    const cartForm = component.querySelector('form');
    const variants = JSON.parse(component.querySelector('[data-bw-deposit-variants]')?.textContent || '[]');
    if (!button || button.disabled || button.getAttribute('data-downpay-listener') !== 'true' || !form || !cartForm) {
      throw new Error('The deposit option is not ready. Please wait for it to load.');
    }
    if (form.elements.namedItem('product-id')?.value !== component.dataset.bwDepositProduct) {
      throw new Error('The deposit option does not match this product.');
    }
    const variantId = cartForm.elements.namedItem('id')?.value;
    const planId = form.elements.namedItem('selling_plan')?.value;
    const variant = variants.find((item) => String(item.id) === variantId);
    if (!variant?.available || form.elements.namedItem('id')?.value !== variantId ||
        !planId || !variant.plans.some((id) => String(id) === planId)) {
      throw new Error('Please select a valid deposit option for the selected product option.');
    }
    const quantity = Number(scope.querySelector('.quantity__input.prdct_pg')?.value);
    if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Please enter a valid quantity.');
    return { form, variantId, planId, quantity };
  };

  window.bwBossborotDeposit = {
    prepareCart(component, formData) {
      const selection = readSelection(component);
      formData.set('id', selection.variantId);
      formData.set('quantity', String(selection.quantity));
      // Keep the separate Cart form out of Downpay's document-wide plan selector.
      formData.set('selling_plan', selection.planId);
    },
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('#downpay-buy-button');
    const component = button?.closest('product-info')?.querySelector('product-form[data-bw-deposit-product]');
    if (!component) return;
    try {
      const selection = readSelection(component);
      let quantity = selection.form.elements.namedItem('quantity');
      if (!quantity) {
        quantity = document.createElement('input');
        quantity.type = 'hidden';
        quantity.name = 'quantity';
        selection.form.appendChild(quantity);
      }
      quantity.value = String(selection.quantity);
      component.handleErrorMessage();
      // Downpay retains its own click handler, callback and native form submission.
    } catch (error) {
      event.preventDefault();
      event.stopImmediatePropagation();
      component.handleErrorMessage(error.message);
    }
  }, true);
})();
